import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";
import { MatchableItem, MatchItemType } from "../types";

export const OpenAmountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        const { openAmount, amount, type } = row.original;

        // Transactions have no "open" concept of their own — the full amount
        // is always available for matching. Render the amount in the Open
        // column so it vertically aligns with bill/invoice Open amounts (and
        // the Difference row) inside the matches panel (PRO-9346).
        const displayAmount =
            openAmount ?? (type === MatchItemType.TRANSACTION ? amount : null);

        if (displayAmount == null) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <Amount amount={displayAmount} showNegative />
            </ViewTableCell>
        );
    },
);
OpenAmountCell.displayName = "OpenAmountCell";
